import { notificationAlerts, setAuthorizationHeader } from '../../api';
import {
  DISMISS_NOTIFICATION_ALERT,
  FETCH_NOTIFICATION_ALERTS_FAILURE,
  FETCH_NOTIFICATION_ALERTS_REQUEST,
  FETCH_NOTIFICATION_ALERTS_SUCCESS,
} from '../../constants/ActionTypes';
import storage from '../../storage';
import { getIsNotificationAlertsFetching } from './getters';
import { errorHandler } from '../../helpers/error-handler';

export const fetchNotificationAlerts =
  (page = 1) =>
  async (dispatch, getState) => {
    try {
      if (getIsNotificationAlertsFetching(getState())) {
        return Promise.resolve();
      }

      setAuthorizationHeader(storage.getItem('token'));

      dispatch({
        type: FETCH_NOTIFICATION_ALERTS_REQUEST,
      });

      const data = await notificationAlerts.getNotificationAlerts(page);

      dispatch({
        type: FETCH_NOTIFICATION_ALERTS_SUCCESS,
        data,
      });

      return Promise.resolve();
    } catch (e) {
      const processedError = errorHandler(e);

      dispatch({
        type: FETCH_NOTIFICATION_ALERTS_FAILURE,
        data: processedError,
      });

      return Promise.reject(e);
    }
  };

export const dismissNotificationAlert = (id) => (dispatch) => {
  dispatch({
    type: DISMISS_NOTIFICATION_ALERT,
    id: id,
  });

  return Promise.resolve();
};

export const markNotificationAlertAsRead =
  (seqIds = []) =>
  async () => {
    try {
      if (!seqIds.length) {
        return;
      }

      setAuthorizationHeader(storage.getItem('token'));
      await notificationAlerts.markNotificationAsRead(seqIds);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
